import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeModule } from '../../theme.module';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'dum-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  items: MenuItem[];
  showMenuMovil: boolean = false;
  constructor(
    private router: Router,
    private translateService: TranslateService
    ) {}

  ngOnInit(): void {
    this.items = [
      {
        label: this.translateService.instant('GLOBAL.OBJETIVO'),
        routerLink: ['/objetivo'] },
      {
        label: 'Gestión',
        icon: null,
        routerLink: ['/gestion'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Historia',
        icon: null,
        routerLink: ['/historia'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Preguntas frecuentes',
        icon: null,
        routerLink: ['/preguntas-frecuentes'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Noticias',
        icon: null,
        routerLink: ['/noticias'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Tipo de usuarios',
        icon: null,
        routerLink: ['/usuarios'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Trámites disponibles',
        icon: null,
        routerLink: ['/tramites'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Plano',
        icon: null,
        routerLink: ['/plano'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Apps disponibles',
        icon: null,
        routerLink: ['/apps'],
        routerLinkActiveOptions: { exact: true },
      },
      {
        label: 'Contacto',
        icon: null,
        routerLink: ['/contacto'],
        routerLinkActiveOptions: { exact: true },
      },
    ];
  }

  mostrarOcultarMenuMovil() {
    this.showMenuMovil = !this.showMenuMovil;
  }
}
